import { RebateTypeDto } from './rebate-type.dto';
import { RebateCriteriaTypeDto } from './rebate-criteria-type.dto';
import { RebatePaymentMethodDto } from './rebate-payment-method.dto';
import { RebateSettlementFrequencyDto } from './rebate-settlement-frequency.dto';
import { User } from 'firebase';
import { StockDto } from '../stock.dto';
import { SupplierDto } from '../supplier.dto';

export class RebateDto {
  id?: number;
  name: string;
  supplierId: number;
  rebateTypeId: number;
  startDate: string;
  endDate: string;
  criteriaTypeId: number;
  criteriaValue?: number;
  monetaryFixedAmount?: number;
  monetaryPercentageOfSpend?: number;
  monetaryFixedValue?: number;
  monetarySettlementFrequencyId?: number;
  monetaryPaymentMethodId?: number;
  monetaryIsInvoiceRequired?: boolean;
  productVolume?: number;
  productSettlementFrequencyId?: number;
  productIsPORequired?: boolean;
  merchantGroupId: number;
  supplier?: SupplierDto;
  rebateType?: RebateTypeDto;
  criteria?: RebateCriteriaTypeDto;
  monetaryPaymentMethod?: RebatePaymentMethodDto;
  monetarySettlementFrequency?: RebateSettlementFrequencyDto;
  productSettlementFrequency?: RebateSettlementFrequencyDto;
  createdByUser?: User;

  selectedStocks?: StockDto[]; // {id: number, name: string}
  selectedStocksCategories?: { id: number, name: string }[];
  merchants?: { id: number, name: string }[];
  merchantLocations?: { id: number, name: string }[]; // cost centers
  merchantEntities?: { id: number, name: string }[]; // business entities

}